"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    props: ["task-data-id"],
    data: function () {
        var model = this.$root.$data;
        var iterations = model.iterations || [];
        // Tri par numéro d'itération
        iterations.sort(function (a, b) { return a.Iteration - b.Iteration; });
        return {
            iterations: iterations,
            fileTypes: model.fileTypes
        };
    },
    methods: {
        getTitle: function (iteration) {
            var date = new Date(iteration.Created);
            var createdDate = date.toLocaleDateString();
            var createdTime = date.toLocaleTimeString();
            return iteration.Progress.title + "\n" + iteration.AuthorName + "\nLe " + createdDate + " \u00E0 " + createdTime;
        },
        openTask: function (iteration) {
            if (iteration.Id == this.taskDataId) {
                return;
            }
            var $modal = $('#modal-workflow-iteration');
            var $title = $modal.find(".modal-title");
            $title.text(iteration.TaskName + " - " + this.getTitle(iteration));
            var $body = $modal.find(".modal-body");
            var $form = $body.find("form");
            var originalContent = $modal.data("originalContent");
            if (originalContent == null) {
                originalContent = $form.html();
                $modal.data("originalContent", originalContent);
            }
            else {
                // Remise à zéro du formulaire, parce qu'on ne peut pas ouvrir plusieurs fois un Vue
                $form.html(originalContent);
            }
            $modal.modal('show');
            $body.initWorkflowTask({
                data: iteration.Data,
                dataStore: iteration.DataStore,
                existingDocs: iteration.ExistingDocs,
                fileTypes: this.fileTypes
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Output/Iterations.vue
// module id = 218
// module chunks = 0